/** Web Share API helpers: one tap to the system share sheet (Save Image, Mail, Messages, Teams…). */

export type ShareOutcome = "shared" | "cancelled" | "unsupported";

/** True when the browser can hand a PNG file to the native share sheet (iOS Safari, Android Chrome, Windows Edge/Chrome). */
export function canShareFiles(): boolean {
	try {
		if (typeof navigator === "undefined" || typeof navigator.share !== "function" || typeof navigator.canShare !== "function") return false;
		const probe = new File([new Uint8Array([0])], "probe.png", { type: "image/png" });
		return navigator.canShare({ files: [probe] });
	} catch {
		return false;
	}
}

/** Coarse pointer = phone or tablet; used to promote Share to the primary action. */
export function isTouchDevice(): boolean {
	try {
		return typeof matchMedia === "function" && matchMedia("(pointer: coarse)").matches;
	} catch {
		return false;
	}
}

/** Share a PNG through the system share sheet. Must be called from a user gesture. */
export async function sharePng(blob: Blob, filename: string, title: string, text?: string): Promise<ShareOutcome> {
	if (!canShareFiles()) return "unsupported";
	const file = new File([blob], filename, { type: "image/png" });
	if (!navigator.canShare({ files: [file] })) return "unsupported";
	try {
		await navigator.share({ files: [file], title, text });
		return "shared";
	} catch (err) {
		if (err instanceof DOMException && err.name === "AbortError") return "cancelled";
		throw err;
	}
}
